import { reactive, computed } from "vue"
import fr from "./locals-fr.json"
import en from "./locals-en.json"

const LOCALES = { fr, en }
const STORAGE_KEY = "denturo_lang"

const readStoredLang = () => {
	try {
		const v = localStorage.getItem(STORAGE_KEY)
		return v === "en" || v === "fr" ? v : "fr"
	} catch {
		return "fr"
	}
}

const state = reactive({ lang: readStoredLang() })

export const lang = computed(() => state.lang)

export const setLang = (next) => {
	if (next !== "fr" && next !== "en") return
	state.lang = next
	try {
		localStorage.setItem(STORAGE_KEY, next)
	} catch {
		// ignore
	}
	document.documentElement.setAttribute("lang", next === "fr" ? "fr-CA" : "en")
}

const resolve = (dict, path) => {
	const segments = path.split(".")
	let cursor = dict
	for (const seg of segments) {
		if (cursor == null || typeof cursor !== "object") return undefined
		cursor = cursor[seg]
	}
	return cursor
}

export const t = (path) => {
	if (!path) return ""
	const primary = resolve(LOCALES[state.lang], path)
	if (typeof primary === "string") return primary
	const fallback = resolve(LOCALES.fr, path)
	return typeof fallback === "string" ? fallback : path
}

// Call once on app boot so <html lang> reflects stored preference.
if (typeof document !== "undefined") {
	document.documentElement.setAttribute(
		"lang",
		state.lang === "fr" ? "fr-CA" : "en"
	)
}
